import axios from "axios";

// const URL_V2 = 'http://eposter-api.entwicklung:8030/api/v2';
const URL_V2 = 'https://'+ process.env.VUE_APP_CONGRESS_SHORT +'.eposter.documedias.systems/api/v2';
export default {
  namespaced: true,

  state: {
    sessionlist: [],
    selectedSession: null
  },
  actions: {
    GET_SESSIONS: function ({commit}) {
      let url = URL_V2 + '/gallery/sessions';
      axios.get(url).then((response) => {
        commit('SET_SESSIONLIST', {sessionlist: response.data})
      })
    },
  },
  mutations: {
    setSelectedSession(state, selectedSession) {
      state.selectedSession = selectedSession;
    },
    SET_SESSIONLIST: (state, {sessionlist}) => {
      state.sessionlist = sessionlist;
    },
  },
  getters: {}
}
